// extracted by mini-css-extract-plugin
export default {"inventoryList__container":"InventoryList_inventoryList__container__btysD"};